module.exports = __webpack_public_path__ + "static/icon-chain.8337b13c.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-chain.png
// module id = 284
// module chunks = 2